import { Menu } from "antd";
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";

import profileFeatureContext from "../../../context/profile-access";

const AccessType = {
  NoAccess: false,
  ReadWrite: true,
  menuItem: "menuItem",
  notAccessible: "not visible",
  accessible: "visible",
};

const AccessControl = ({ ...props }) => {
  const { code, children, page, handleTableAction } = props;
  const profileFeatures = useContext(profileFeatureContext);
  if (!profileFeatures) return null;
  let profileFeature = profileFeatures?.map((pf) => pf).find((f) => f?.name === page);
  if (code === "menuItem") {
    profileFeature?.actions?.push(
      { key: "Menu Items", value: "menuItem", toggle: "menuItem" },
      { key: "View All Clips", value: "view_all_clips", toggle: true },
    );
  }

  const accessKeys = {};

  profileFeature?.actions?.forEach((item) => {
    accessKeys[item.value] = item.toggle;
  });

  let isCodeExist = profileFeature?.actions?.find(({ value }) => value === code)?.toggle;
  if (code === "accessible") {
    isCodeExist = profileFeature?.accessbility;
  }
  const menuItems = [];
  switch (isCodeExist) {
    case AccessType.ReadWrite:
      return children;
    case AccessType.menuItem:
      handleTableAction(accessKeys, menuItems);
      return !!menuItems.length && React.createElement(Menu, { items: menuItems });
    case AccessType.NoAccess:
      return null;
    case AccessType.notAccessible:
      return <Navigate to="/dashboard" />;
    case AccessType.accessible:
      return children;
  }
};

export default AccessControl;
